export default {"src":"/planos/_next/static/media/youtube-icon.b5793715.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};